'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftTopNavigation', function() {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'views/common/top-navigation.html'
      };
    });
})(angular);

